import React, { useState } from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import { useTheme } from '../../theme/ThemeProvider';

// Последовательная шкала одного оттенка (светлый → тёмный); в тёмной теме — наоборот, к яркому
const RAMP = {
  light: ['#e3eefb', '#b9d3f3', '#7fb0e8', '#4189dc', '#2a78d6', '#1b4f8f'],
  dark: ['#1b2a3e', '#1f4673', '#2a65a8', '#3987e5', '#74abef', '#b5d3f7'],
};
const EMPTY = { light: '#f4f4f5', dark: '#27272a' };
// Понедельник первым
const WEEK = [1, 2, 3, 4, 5, 6, 0];

/** Тепловая карта чеков: дни недели × часы. cells: [{ weekday, hour, visits }] */
export default function Heatmap({ cells }) {
  const { t, fmt } = useI18n();
  const { isDark } = useTheme();
  const mode = isDark ? 'dark' : 'light';
  const [hover, setHover] = useState(null);

  const grid = new Map(cells.map((c) => [`${c.weekday}:${c.hour}`, c.visits]));
  const max = Math.max(1, ...cells.map((c) => c.visits));
  const color = (v) => (v ? RAMP[mode][Math.min(RAMP[mode].length - 1, Math.floor((v / max) * RAMP[mode].length))] : EMPTY[mode]);
  const label = (day, hour, count) => t('analytics.heatCell', { day: t(`analytics.weekdays.${day}`), hour: String(hour).padStart(2, '0'), count: fmt.number(count) });

  return (
    <div>
      <div className="overflow-x-auto custom-scrollbar">
        <table className="w-full min-w-[420px] table-fixed border-separate" style={{ borderSpacing: 2 }}>
          <colgroup>
            <col className="w-8" />
            {Array.from({ length: 24 }, (_, h) => <col key={h} />)}
          </colgroup>
          <thead>
            <tr>
              <th />
              {Array.from({ length: 24 }, (_, h) => (
                <th key={h} scope="col" className="tabular p-0 text-center text-[10px] font-normal text-zinc-400">
                  {h % 3 === 0 ? h : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {WEEK.map((day) => (
              <tr key={day}>
                <th scope="row" className="pr-1.5 text-left text-[11px] font-normal text-zinc-500">{t(`analytics.weekdays.${day}`)}</th>
                {Array.from({ length: 24 }, (_, h) => {
                  const v = grid.get(`${day}:${h}`) || 0;
                  return (
                    <td
                      key={h}
                      className="h-5 rounded-[3px] p-0"
                      style={{ background: color(v) }}
                      title={label(day, h, v)}
                      onMouseEnter={() => setHover({ day, h, v })}
                      onMouseLeave={() => setHover(null)}
                    />
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex flex-wrap items-center justify-between gap-3 text-[11px] text-zinc-500">
        <span className="tabular min-h-[1rem]" aria-live="polite">{hover ? label(hover.day, hover.h, hover.v) : ''}</span>
        <span className="flex items-center gap-1.5">
          {t('analytics.fewer')}
          {RAMP[mode].map((c) => <span key={c} className="h-3 w-3 rounded-[3px]" style={{ background: c }} aria-hidden="true" />)}
          {t('analytics.more')}
        </span>
      </div>
    </div>
  );
}
